import { Meta } from "@/shared/components";
import { BillingReports } from "@/admin/features/billing";

export function BillingReportsPage() {
  return (
    <>
      <Meta title="Отчёты доли с продаж" />
      <BillingReports />
    </>
  );
}
